// Compact 3-radio selector used on every person form (guest, disciple,
// directory, household, prayer, checkin, tracker signup). Picking Male / Female
// automatically applies the "Bro." / "Sis." title prefix everywhere the name
// is rendered via formatDisplayName().
//
// Props:
//   value      "male" | "female" | null
//   onChange   (next: string|null) => void
//   testid     optional test id prefix (defaults to "gender")

export default function GenderField({ value, onChange, testid = "gender", label = "Gender" }) {
  const ordered = [
    { key: "male", label: "Male (Bro.)" },
    { key: "female", label: "Female (Sis.)" },
    { key: null, label: "Prefer not to say" },
  ];
  const current = value === "male" || value === "female" ? value : null;
  return (
    <div className="text-sm" data-testid={`${testid}-group`}>
      {label && (
        <div className="mb-1.5 text-xs uppercase tracking-wide" style={{ color: "var(--muted)" }}>
          {label}
        </div>
      )}
      <div className="flex flex-wrap gap-2">
        {ordered.map((opt) => {
          const active = current === opt.key;
          return (
            <button
              type="button"
              key={String(opt.key)}
              onClick={() => onChange(opt.key)}
              data-testid={`${testid}-${opt.key || "none"}`}
              className="px-3 py-1.5 text-sm border rounded-full transition-colors"
              style={{
                borderColor: active ? "var(--ember)" : "var(--border-subtle)",
                background: active ? "var(--ember)" : "var(--surface)",
                color: active ? "#fff" : "var(--ink)",
              }}
            >
              {opt.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
